import React, { useRef, useState, useEffect } from "react";
import { useInput } from "react-admin";
import { TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

function uniqueBy(a, key, condition) {
    let seen = {};
    for (let i in a) {
        const item = a[i];
        if (seen[key(item)] == null || condition(item))
            seen[key(item)] = item;
    }
    return Object.keys(seen).map(key => seen[key]);
}
export default function RaAutocompleteInput(props) {
    const { resourcePath, resourceParam, source, filter, label = "", getOptionValue, getOptionLabel, style = {}, clearable = true, useAccessKeyId = false, multiple = false, uniqueOptions = (option => false), onSelect, limit = 10, customSort = ["id", "ASC"], accessKeyIdValue, clearClientInfo = false, ...rest } = props;
    const { input: { value, onChange } } = useInput(props);
    const { input: { value: accessKeyId, onChange: setAccessKeyId } } = useInput({ ...props, id: "access_key_id", source: "access_key_id" });
    //const notify = useNotify();

    const [selectedOption, setSelectedOption] = useState(multiple ? [] : null);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    const fetchParkingTimeout = useRef(null);

    const handleOnChange = (newValue) => {
        onChange(newValue);
        if (onSelect)
            onSelect(newValue);
    };

    const handleInputChange = (event, value) => {
        setSearchText(value);
    };

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if ((token != null && token !== "") && (!useAccessKeyId || (accessKeyId != null && accessKeyId !== ""))) {
            setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ [resourceParam ? resourceParam : source]: searchText, access_key: useAccessKeyId ? accessKeyId : undefined, includeSocieties: true, ...filter }),
                sort: JSON.stringify(customSort),
                page: 1,
                perPage: limit
            }
            fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    setLoading(false);
                    if (responseJson.success) {
                        if (resourcePath === "cardsInventory") {
                            setOptions(responseJson.data);
                        } else {
                            let tempOptions = uniqueBy(responseJson.data, getOptionValue, uniqueOptions);
                            if (multiple)
                                tempOptions = [{ id: "All" }].concat(tempOptions);
                            setOptions(tempOptions);
                        }
                        console.log(responseJson.data)
                        if (responseJson.data.length === 1 && searchText === "" && !filter)
                            onOptionSelect(null, responseJson.data[0]);
                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const onOptionSelect = (event, option) => {
        if (multiple) {
            if (option[option.length - 1] && option[option.length - 1].id === "All") {
                let tempOptions = options.slice(1);
                setSelectedOption(tempOptions);
                handleOnChange("All");
            } else {
                setSelectedOption(option);
                handleOnChange(option.map(getOptionValue));

            }
        } else {
            setSelectedOption(option);
            handleOnChange(option ? getOptionValue(option) : null);
        }
    };

    useEffect(() => {
        if (accessKeyIdValue) setAccessKeyId(accessKeyIdValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (value != null && value !== "" && (!useAccessKeyId || (accessKeyId != null && accessKeyId !== ""))) {
            setLoading(true);
            const filters = { access_key: useAccessKeyId ? accessKeyId : undefined, ...filter };
            if (isNaN(value)) {
                filters[resourceParam ? resourceParam : source] = value;
            } else {
                filters.id = value;
            }
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify(filters)
            }
            fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    setLoading(false);
                    if (responseJson.success && responseJson.data && responseJson.data.length > 0) {
                        onOptionSelect(null, responseJson.data[0]);
                    }
                })
                .catch((e) => {
                    setLoading(false);
                });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [searchText, accessKeyId, filter]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() =>{
        setSelectedOption(multiple ? [] : null)
        setSearchText("")
    }, [clearClientInfo]) // eslint-disable-line react-hooks/exhaustive-deps

    return <Autocomplete
        multiple={multiple}
        blurOnSelect
        disableClearable={!clearable}
        getOptionLabel={multiple ? (option => option.id === "All" ? "All" : getOptionLabel(option)) : getOptionLabel}
        getOptionSelected={(option, value) => option && getOptionValue(option) === getOptionValue(value)}
        loading={loading}
        noOptionsText="No Records"
        onInputChange={handleInputChange}
        options={options}
        renderInput={params => <TextField {...params} label={label} variant="outlined" size="small" />}
        onChange={onOptionSelect}
        value={selectedOption}
        style={style}
        disabled={useAccessKeyId && (accessKeyId == null || accessKeyId === "")}
        {...rest}
    />;
}